/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import classname from 'classnames';
import TextContentBlockComponent from '../../components/text-content-block';
import { IContentWithMediaData } from './content-with-media.data';
import { IContentWithMediaProps } from './content-with-media.props.autogenerated';
import MediaContentBlockComponent from './media-content-block';

// ==============================================================================
// CLASS DEFINITIONS
// ==============================================================================
/**
 * ContentWithMedia component
 * @extends {React.Component<IContentWithMediaProps<IContentWithMediaData>>}
 */
class ContentWithMedia extends React.Component<IContentWithMediaProps<IContentWithMediaData>> {

    // ==============================================================================
    // PUBLIC METHODS
    // ==============================================================================

    // -----------------------------------------------------------
    // -----------------------------------------------------------
    public render(): JSX.Element {
        const { className } = this.props.config;

        return (
            <div className={classname('row', className)}>
                <div className='col'>
                    {this._leftColumn}
                </div>
                <div className='col'>
                    {this._rightColumn}
                </div>
            </div>
        );
    }

    // ==========================================================================
    // JSX CONSTRUCTORS
    // ==========================================================================

    // -----------------------------------------------------------
    // -----------------------------------------------------------
    private get _leftColumn(): JSX.Element {
        const { orientation } = this.props.config;
        return (orientation === 'textLeft') ? this._textColumn : this._mediaColumn;
    }

    // -----------------------------------------------------------
    // -----------------------------------------------------------
    private get _rightColumn(): JSX.Element {
        const { orientation } = this.props.config;
        return (orientation === 'textRight') ? this._textColumn : this._mediaColumn;
    }

    // -----------------------------------------------------------
    // -----------------------------------------------------------
    private get _mediaColumn(): JSX.Element {
        return (<MediaContentBlockComponent config={this.props.config} />);
    }

    // -----------------------------------------------------------
    // -----------------------------------------------------------
    private get _textColumn(): JSX.Element {

        const config = this.props.config;
        const contentBlockNoHeadings = this.props.slots.contentBlockNoHeadings;

        const contentBlockConfig = {
            backgroundImage: config.textBackgroundImage,
            callToActionLink: config.textCallToActionLink,
            callToActionText: config.textCallToActionText,
            callToActionYoutube: config.textCallToActionYoutube,
            category: config.textCategory,
            className: 'content-with-media-text',
            copy: config.textCopy,
            summary: config.textSummary,
            title: config.textTitle,
            contentBlockNoHeadings:contentBlockNoHeadings
        };

        return (
            <TextContentBlockComponent
                config={contentBlockConfig}
                imageGridSettings={this.props.context.request.gridSettings}
            />
        );
    }
}

export default ContentWithMedia;
